import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Card, Button, Form } from "react-bootstrap";
import Table from "../../../../components/Table";
import styled from "styled-components";
import InputSearch from "../../../../components/InputSearhComponent";
import { getQueryString } from "../../../../utils/Query";
import { getServiceRequest } from "../../../../commons/ServiceRequest";
import { useLoading } from "../../../../context/LoadingContext";
import { useAlert } from "../../../../context/AlertContext";
import { formatInputDate, toFormatISO } from "../../../../utils/Time";
import { formatDate } from "../../../../commons/FormatValue";
import TableLimitPagination from "../../../../components/TableLimitPagination";
import PropTypes from "prop-types";
import SequenceStatusService from "../../../../services/sequencestatus.service";
import TechnicianReceiveService from "../../../../services/technicianreceive.service";
import moment from "moment";

const StyledCardBody = styled(Card.Body)`
  overflow-x: auto;
  z-index: 0;

  .barcode-field {
    font-family: "YourCode39Font", sans-serif;
  }
`;

export default function CheckJobdetail({ defaultData }) {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const { showAlert } = useAlert();

  const [tableData, setTableData] = useState([]);
  const [currentDate, setCurrentDate] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [JobType, setJobType] = useState([]);
  const [statusSeq, setStatusSeq] = useState([]);

  const columns = [
    {
      name: "ลำดับ",
      selector: (row) => row.rowIndex,
      sortable: true,
      width: "110px"
    },
    {
      name: "ประเภทงาน",
      selector: (row) => row.Job_Type_Name,
      sortable: true,
      width: "180px"
    },
    {
      name: "เลขที่ใบสั่งงาน",
      selector: (row) => row.Seq_No,
      sortable: true,
      width: "200px"
    },
    {
      name: "เลขที่ใบขอเบิก",
      selector: (row) => row.Bill_Doc_No,
      sortable: true,
      width: "200px"
    },
    {
      name: "เลขที่สาขา",
      selector: (row) => row.Branch_No,
      sortable: true,
      width: "200px"
    },
    {
      name: "ชื่อลูกค้า/สาขา",
      selector: (row) => row.Cus_Name,
      sortable: true,
      width: "200px"
    },
    {
      name: "รายละเอียดสินค้า",
      selector: (row) => row.Item_Name,
      sortable: true,
      width: "280px"
    },
    {
      name: "วันที่เข้างาน",
      selector: (row) => row.Job_Actual_Date,
      format: (row) => formatDate(row?.Job_Actual_Date),
      sortable: true,
      width: "180px"
    },
    {
      name: "ชุดกรอง",
      selector: (row) => row.Qty,
      sortable: true,
      width: "150px"
    },
    {
      name: "หน่วย",
      selector: (row) => row.Unit,
      sortable: true,
    },
    {
      name: "สถานะงาน",
      selector: (row) => row.Depart_St_Name,
      sortable: true,
      width: "180px"
    },
    {
      name: "สถานะใบสั่งงาน",
      selector: (row) => row.Seq_St_Id,
      format: (row) => statusSeq.find(sts => sts.Id == row.Seq_St_Id)?.Seq_St_Name,
      sortable: true,
      width: "200px"
    }
  ];

  const searchInput = [
    {
      name: "sup_team",
      label: "ชื่อทีม/หัวหน้าช่าง",
      classNames: { label: "mb-3" },
      type: "text",
      value: defaultData.team,
      disabled: true,
      size: 3
    },
    {
      name: "sup_team",
      label: "ช่างผู้ปฏิบัติงาน",
      classNames: { label: "mb-3" },
      type: "text",
      value: defaultData.tech_name,
      disabled: true,
      size: 3
    },
    {
      name: "start",
      label: "วันที่เข้างานระหว่างวันที่",
      classNames: { label: "mb-3" },
      type: "date",
      size: 3,
      //disabled: true,
      value: currentDate
    },
    {
      name: "end",
      label: "ถึงวันที่",
      classNames: { label: "mb-3" },
      type: "date",
      size: 3,
      min: 'start',
      value: currentDate
    }
  ];

  useEffect(() => {
    getServiceRequest({
      showAlert,
      setLoading: () => { },
      serviceRequest: SequenceStatusService.getAllSequenceStatuses(),
      callback: (res) => setStatusSeq(res)
    });
  }, []);

  useEffect(() => {
    setJobType(defaultData.job_type)
  }, [defaultData]);
  const [querySearch, setQuerySearch] = useState()

  const getDataTable = (search) => {
    const page = search?.page || currentPage
    const limit = search?.limit || rowsPerPage
    const q = {
      ...querySearch,
      page: page, limit: limit, ...search,
      start: toFormatISO(search.start),
      end: toFormatISO(search?.end)
    }
    setQuerySearch(q)
    setCurrentPage(page)
    setRowsPerPage(limit)
    getServiceRequest({
      showAlert,
      setLoading,
      serviceRequest: TechnicianReceiveService.getJobDetail(getQueryString(q)),
      callback: (res) => { pSetData(res.data); }
    });

  }

  const pSetData = (vData) => {
    const newArray = vData?.map((items) => ({
      Id: items.id,
      Job_Type_Id: items.BillOfReqHd?.Job_Type_Id,
      Job_Type_Name: items.BillOfReqHd.Job_Type_Name || JobType.find(item => item.Id === items.BillOfReqHd?.Job_Type_Id)?.Job_Type_Name,
      Seq_No: items.TechnicianPlan.SeqOthersJob?.Seq_Oth_No ||
        items.TechnicianPlan.SeqPmJob?.Seq_Pm_No ||
        items.TechnicianPlan.SeqRepairJob?.Seq_Serv_No ||
        items.TechnicianPlan.SeqInstalljob?.seq_install_no,
      Bill_Doc_No: items.BillOfReqHd.Bill_Doc_No,
      Branch_No: items.TechnicianPlan.SeqOthersJob?.InformOtherJob?.Cus_NumBranch
        || items.TechnicianPlan.SeqInstalljob?.InformInstallJobs?.Customer.Cus_NumBranch,
      // Cus_Id: items.TechnicianPlan.SeqOthersJob.InformOtherJob?.Cus_Id,
      Cus_Name: items.TechnicianPlan.SeqOthersJob?.InformOtherJob?.Customer.Cus_Name
        || items.TechnicianPlan.SeqInstalljob?.InformInstallJobs?.Customer.Cus_Name,
      Item_Name: items.BillOfReqHd?.BillOfReqDt[0]?.Item.Item_Name_TH || items.BillOfReqHd[0]?.Item.Item_Name_EN,
      Job_Actual_Date: formatInputDate(items.TechnicianPlan.job_actual_date, "Local").date,
      Qty: items?.BillOfReqHd?.BillOfReqDt[0]?.ChildBom?.Item_Child_Qty,
      Unit: items?.BillOfReqHd?.BillOfReqDt[0]?.Item.Unit,
      Depart_St_Name: items.TechnicianPlan.TechnicianReceive[0]?.DepartJob?.Depart_St_Name,
      Seq_St_Id: items.TechnicianPlan.TechnicianReceive[0]?.seq_status_id,
    }));
    setTableData(newArray || [])
  };

  return (
    <>

      <Card className="m-1 mb-4 p-4 border-0">
        <Card.Body>
          <InputSearch
            inputField={searchInput}
            showActionButtons={false}
            field={searchInput}
            searchCallback={search => { search ? getDataTable(search) : setTableData([]); setQuerySearch() }}
          />
        </Card.Body>
      </Card>

      <Form >
        <Card className="m-1 mb-4 p-4 border-0">
          <Card.Header className="p-3 d-flex justify-content-between align-items-center border-bottom-0 bg-transparent">
            <Card.Title className="mb-0 fs-2">รายละเอียดงานและจำนวนชุดกรอง</Card.Title>
            <div className="ms-auto">
              <Button
                variant="success"
                className="me-2 my-2 px-5 py-2 text-dark rounded-pill"
                onClick={() => navigate("customer")}
              >
                ข้อมูลติดต่อและนัดหมายลูกค้า
              </Button>
              <Button
                variant="success"
                className="me-2 px-5 py-2 text-dark rounded-pill"
                onClick={() => navigate("checkin")}
              >
                เช็คอิน
              </Button>
            </div>
          </Card.Header>

          <StyledCardBody>
            {/* <Table
              data={searchValue.Array}
              columns={columns}
              defultData={defaultDatas}
              checkBoxShow={false}
              pending={loading}
              editForm={true}
              //activeButton={["delete"]}
              onChangeCallback={(newData) => {
                setSearchValue({ Array: newData });
                setDataModal({ Array: newData });
              }}
            /> */}
            <Table
              data={tableData}
              column={columns}
              searchFilter={tableData}
              pending={loading}
            />
            {!loading &&
              <TableLimitPagination
                data={tableData}
                paginationProps={{
                  rowsPerPage: rowsPerPage,
                  currentPage: currentPage,
                  rowCount: tableData?.length,
                  onChangeRowsPerPage: num => getDataTable({ limit: num, page: 1 }),
                  onChangePage: page => getDataTable({ page: page })
                }}
              />
            }
          </StyledCardBody>

        </Card>
      </Form>
    </>
  );
}

CheckJobdetail.propTypes = {
  defaultData: PropTypes.object,
};